@if (isAuthenticated()) {
  <div class="app" [class.sidebar-collapsed]="sidebarCollapsed()">
    <app-sidebar [isOpen]="sidebarOpen()" (collapsedChange)="onSidebarCollapsedChange($event)" />

    <div class="main">
      <app-header (menuToggle)="toggleSidebar()" />
      <router-outlet />
    </div>
  </div>
} @else {
  <router-outlet />
}
